import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import LOGO from '../../assets/logo.jpg';
const GLOBAL = require('../../Globals');

const bgRedColor = {backgroundColor : '#ffc4c4'}
const bgColor = {backgroundColor : '#FFF'}

class RankList extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			acyear: '',
			cls: '',
			section: '',
			examname: '',
			subject: '',
			_message: '',
			alertClass: '',
			_redirect: false,
			posts: [],
			accyear: [],
			sections: [],
			exams: [],
			subj: [],
			markdata: [],
			fdata: [],
			adata: [],
			count : 0,
			allocateClass: [],
		}
		this.onChange = this.onChange.bind(this);
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		if(e.target.name == 'acyear'){
			this.getexam();
		}
		else if(e.target.name == 'cls'){
			this.getsection();
			this.getsubject();
		}
		else if(e.target.name == 'examname'){
			this.getmark();
		}
		
	}

	componentWillMount() {

		this.getacyear();
		this.getclass();
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				
				let userData = JSON.parse(sessionStorage.getItem('userData'));
				this.state.userId = userData['userid'];
				this.state.userRole = userData['userrole'];
				this.state.staffid = userData['staffid'];
				this.setState({
					staffid: userData['staffid']
				});
				this.getexam();
				if(userData['userrole'] == 'classteacher'){
					this.checkclassteacher();
				}
			}
		});
	}

	checkclassteacher(){
		$("#showLoader").show();
		GetData('employee/checkclassteacher/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					allocateClass : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}
	
	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}
	
	getsection() {
		$("#showLoader").show();
		var ac = $("#year").val();
		var cls = $("#clas").val();
		GetData('section/getsecbyclass/'+ac+'/'+cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sections: responseJson
				});
			}
		});
	}

	getexam() {

		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('exam/getexambyacyear/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.state.marktotal = [];
				this.setState({
					exams: responseJson
				});
				this.state.marktotal = new Array(this.state.exams.length);
			}
		});
	}

	getsubject() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		$("#showLoader").show();
		GetData('assignsubject/getmainsubbycls/' + ac + '/' + cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					subj: responseJson
				});
			}
		});
	}
	
	getmark() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		var exam = $("#exam").val();
		$("#showLoader").show();
		this.setState({classname : '',markdata : [],fdata : [],adata : []});
		GetData('exam/getmarkforranklist/' + ac + '/' + cls + '/' + sec + '/' + exam).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson['mdata'].length > 0) {
				var count = 0;
				if(responseJson['fdata'].length > responseJson['adata'].length){
					count = responseJson['fdata'].length;
				}
				else{
					count = responseJson['adata'].length;
				}
				
				this.setState({
					classname : responseJson['mdata'][0]['class']+' '+responseJson['mdata'][0]['section'],
					markdata: responseJson['mdata'],
					fdata: responseJson['fdata'],
					adata: responseJson['adata'],
					count : count,
				});
			}
		});
	}

	gettotal(regno) {

		var tot = 0;
		for (var j = 0; j < this.state.subj.length; j++) {
			var sub = this.state.subj[j].subject;
			var mark = this.checkmarks(regno, sub);
			if (mark!= false) {
				if( parseFloat(mark)!='-1'){
					tot += parseFloat(mark);
				}
			}
		}

		return tot;
	}

	checkmarks(regno, sub) {

		var bstate = false;

		for (var ii = 0; ii < this.state.markdata.length; ii++) {

			if (this.state.markdata[ii].subject == sub && this.state.markdata[ii].studentid == regno) {

				bstate = this.state.markdata[ii].mark;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;

	}
	
	getexamname(){
		var exam = $("#exam").val();
		var d = this.state.exams;
		
		var index = d.findIndex(function(obj){
			return(obj.id == exam);
		});
		if(index > -1){
			return d[index]['exam'];
		}
	}
	
	getfailabsent(){
		var result = [];
		for(var i=0;i<this.state.count;i++){
			
			result.push(<tr>
				<td>{i+1}</td>
				<td>{this.getfailure(i,'stdname')}</td>
				<td>{this.getfailure(i,'sub')}</td>
				<td>{this.getabsent(i,'stdname')}</td>
				<td>{this.getabsent(i,'sub')}</td>
			</tr>)	
		}
		return result;
	}
	
	getfailure(index,field){
		var f = this.state.fdata;
		if(f.length>index){
			return f[index][field];
		}
	}
	
	getabsent(index,field){
		var a = this.state.adata;
		if(a.length>index){
			return a[index][field];
		}
	}
	
	checkClass(cls){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.class == cls);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	checkSection(sec){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.section == sec);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

		}

		var exa = this.state.exams;
		var items = this.state.posts;
		var acyear = this.state.accyear;
		var sub = this.state.subj;

		if (this.state.acyear != '' && this.state.cls != '' && this.state.section != '' && this.state.examname != '') {

			$("#abserve").show();
		}
		else {

			$("#abserve").hide();
		}
		
		var total=0;
		var rank=0;

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Rank List</strong>
									<span style={{float:'right'}}>
										<ReactHTMLTableToExcel
											id="test-table-xls-button"
											className="download-table-xls-button"
											table="table-to-xls"
											filename="RankList"
											sheet="tablexls"
											buttonText="Excel" />
									</span>
									<Row>
										<Col md={3} sm={12} xs={12}>
											<label>Academic Year</label>
											<select name="acyear" onChange={this.onChange} className="form-control" required id="year">
												<option value="">Select Academic Year</option>
												{
													acyear.map(function (item) {
														return <option value={item.id}>{item.value}</option>;
													})
												}
											</select>
										</Col>
										<Col md={3} sm={12} xs={12}>
											<label>Class</label>
											<select name="cls" onChange={this.onChange} className="form-control" required id="clas">
												<option value="">Select Class</option>
												{(this.state.userRole == 'classteacher') ?
													items.map((item)=>{
														if(this.checkClass(item.id)){
															return <option value={item.id}>{item.class}</option>;
														}
													})
													:
													items.map(function (item) {
														return <option value={item.id}>{item.class}</option>;
													})
												}
											</select>
										</Col>
										<Col md={3} sm={12} xs={12}>
											<label>Section</label>
											<select name="section" onChange={this.onChange} className="form-control" required id="secs">
												<option value="">Select Section</option>
												{(this.state.userRole == 'classteacher') ?
													this.state.sections.map((item)=>{
														if(this.checkSection(item.section)){
															return <option value={item.section}>{item.secs}</option>;
														}
													})
													:
													this.state.sections.map(function (item) {
														return <option value={item.section}>{item.secs}</option>;
													})
												}
											</select>
										</Col>
										<Col md={3} sm={12} xs={12}>
											<label>Exam</label>
											<select name="examname" onChange={this.onChange} className="form-control" required id="exam">
												<option value="">Select Exam</option>
												{
													exa.map(function (item) {
														return <option value={item.id}>{item.exam}</option>;
													})
												}
											</select>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
								{this.state.markdata.length > 0 ?
									<Row id="abserve">
										<Col md="12">
											<Table responsive bordered id="table-to-xls">
												<thead>
													<tr>
														<td align="center" colSpan={5}>
															{/*<img src={LOGO} width="90px" />&emsp;&emsp;&emsp;*/}
															<b style={{fontSize : '20px'}}>{GLOBAL.Scl_NAME}</b>
														</td>
													</tr>
													<tr>
														<td align="center" colSpan={5}><b>{this.getexamname()} {this.state.classname}</b></td>
													</tr>
													<tr>
														<th>S.No</th>
														<th>Reg No</th>
														<th>Name of the student</th>
														<th>Total</th>
														<th>Rank</th>
													</tr>
												</thead>
												<tbody>
													{this.state.markdata.map((item, index) =>{
														if(parseFloat(total) == parseFloat(item.total)){
															rank = rank;
														}
														else{
															rank=rank+1;
														}
														total = parseFloat(item.total);
														
														return <tr key={item}>
															<td>{index + 1}</td>
															<td>{item.studentid}</td>
															<td>{item.stdname}</td>
															<td align="center">{parseFloat(item.total)}</td>
															<td align="center">{rank}</td>
														</tr>
													})}
													<tr>
														<td align="center" colSpan={5} height="50"></td>
													</tr>
													<tr>
														<td align="center" colSpan={3}><b>FAILURES</b></td>
														<td align="center" colSpan={2}><b>ABSENTEES</b></td>
													</tr>
													{this.getfailabsent()}
												</tbody>
											</Table>
										</Col>
									</Row> : ''}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default RankList;


// WEBPACK FOOTER //
// ./src/exams/Report/RankList.js